interface EmailAddress {
  name?: string;
  address: string;
}

interface Recipient {
  emailAddress: EmailAddress;
}

interface EmailBody {
  contentType: string;
  content: string;
}

export interface EmailJson {
  from?: { emailAddress: EmailAddress };
  toRecipients?: Recipient[];
  subject?: string;
  sentDateTime?: string;
  internetMessageId?: string;
  body?: EmailBody;
}

export function constructCustomEmlContent(json: EmailJson): string {
  if (!json) return '';

  const formatDateToRfc2822 = (dateString: string): string => {
    const date = new Date(dateString);
    return date.toUTCString().replace('GMT', '+0000');
  };

  const from = json.from?.emailAddress;
  const toRecipients = json.toRecipients ?? [];
  const subject = json.subject ?? '';
  const sentDateTime = json.sentDateTime ?? new Date().toISOString();
  const messageId = json.internetMessageId ?? `<${Date.now()}@generated.local>`;
  const body = json.body ?? { contentType: 'text/plain', content: '' };

  const to = toRecipients
    .map((recipient) => {
      const name = recipient.emailAddress.name ?? '';
      const address = recipient.emailAddress.address;
      return `${name} <${address}>`.trim();
    })
    .filter(Boolean)
    .join(', ');

  const contentType = body.contentType.toLowerCase().includes('html')
    ? 'text/html'
    : 'text/plain';

  const charset = 'UTF-8';

  const headers = [
    `From: ${from?.name ?? ''} <${from?.address ?? ''}>`,
    `To: ${to}`,
    `Subject: ${subject}`,
    `Date: ${formatDateToRfc2822(sentDateTime)}`,
    `Message-ID: ${messageId}`,
    'MIME-Version: 1.0',
    `Content-Type: ${contentType}; charset="${charset}"`,
    'Content-Transfer-Encoding: 7bit',
  ];

  return headers.join('\r\n') + '\r\n\r\n' + body.content;
}
